import React from 'react'
import styled from 'styled-components/macro'

styled

export const Failed = 'Failed'
export const Uploaded = 'Uploaded'
export const Queued = 'Queued'